import React from 'react';
import { Link } from 'react-router-dom';

const GRID_BG = {
  backgroundImage:
    'linear-gradient(rgba(201,168,76,0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.12) 1px, transparent 1px)',
  backgroundSize: '60px 60px',
};

const leaders = [
  {
    initials: 'CEO',
    name: '[Name]',
    title: 'Chief Executive Officer',
    bio: 'Placeholder — please provide the CEO\'s name, background, and professional bio. Include years of experience, relevant government contracting history, and areas of expertise.',
  },
  {
    initials: 'COO',
    name: '[Name]',
    title: 'Chief Operating Officer',
    bio: 'Placeholder — please provide the COO\'s name, background, and professional bio. Include operational leadership experience and government sector expertise.',
  },
];

const LeadershipTeam = () => {
  return (
    <div className="pt-20">

      {/* Page header */}
      <section className="relative bg-navy-800 py-20 overflow-hidden">
        <div className="absolute inset-0" style={GRID_BG} />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-2 text-sm text-slate-400 mb-6">
            <Link to="/" className="hover:text-gold-400 transition-colors">Home</Link>
            <span>/</span>
            <span className="text-gold-400">Leadership Team</span>
          </nav>
          <p className="text-gold-500 text-sm font-bold uppercase tracking-widest mb-4">About DTX</p>
          <h1 className="text-4xl md:text-5xl font-black text-white font-heading mb-4">Leadership Team</h1>
          <p className="text-slate-300 text-lg max-w-2xl leading-relaxed">
            The experienced professionals guiding DTX Digital Transformation's mission and growth.
          </p>
        </div>
      </section>

      {/* Leaders grid */}
      <section className="bg-slate-50 py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-10">
            {leaders.map((l) => (
              <div key={l.title} className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100 text-center hover:border-gold-200 hover:shadow-md transition-all">
                <div className="w-24 h-24 rounded-full bg-navy-800 flex items-center justify-center mx-auto mb-5 shadow-md">
                  <span className="text-gold-500 font-black text-xl font-heading">{l.initials}</span>
                </div>
                <h3 className="text-xl font-bold text-navy-800 font-heading">{l.name}</h3>
                <p className="text-gold-600 text-sm font-semibold mt-1 mb-5 uppercase tracking-wide">{l.title}</p>
                <p className="text-slate-500 text-sm leading-relaxed">{l.bio}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gold-500/10 border border-gold-200 rounded-2xl p-8 text-center">
            <p className="text-navy-800 font-semibold mb-2">Ready to meet the team?</p>
            <p className="text-slate-500 text-sm mb-5">
              Contact us to connect with our leadership directly or to request an introduction for contracting purposes.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-navy-800 hover:bg-navy-700 text-white px-6 py-3 rounded-xl font-bold text-sm transition-colors"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default LeadershipTeam;
